export default __webpack_public_path__ + "./images/ms.aec8e88e.png";